import './button'
import './image'
import './text'
import './icon'
import './faq'
import './tag'
import './cards'
import './table'
import './pagination'
